<template>
  <TransitionRoot
    as="template"
    :show="isMobileMenuOpened"
  >
    <Dialog
      class="lg:hidden"
      @close="emit('close', false)"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-in duration-100"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 z-50 bg-gray-900/20 backdrop-blur-sm motion-reduce:transition-none" />
      </TransitionChild>

      <TransitionChild
        as="template"
        enter="transition ease-out duration-300"
        enter-from="opacity-0 translate-x-4"
        enter-to="opacity-100 translate-x-0"
        leave="transition ease-in duration-100"
        leave-from="opacity-100 translate-x-0"
        leave-to="opacity-0 translate-x-4"
      >
        <DialogPanel class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm shadow-float sm:ring-1 sm:ring-gray-900/10 motion-reduce:transition-none">
          <div class="flex items-center justify-between">
            <nuxt-link
              to="/"
              class="-m-1.5 p-1.5"
              @click="emit('close', false)"
            >
              <span class="sr-only">
                {{ appName }}
              </span>

              <img
                :alt="appLogoAlt"
                :src="appLogoUrl"
                class="h-8 w-auto"
              />
            </nuxt-link>

            <button
              type="button"
              class="-m-2.5 inline-flex items-center justify-center rounded-xl p-2.5 text-gray-900 hover:text-brand-700 hover:bg-brand-50 active:bg-brand-50 transition"
              @click.prevent="emit('close', false)"
            >
              <span class="sr-only">
                Fermer le menu
              </span>

              <icon
                name="ph:x"
                aria-hidden="true"
                class="size-6"
              />
            </button>
          </div>

          <!-- The reveal engine only scans mutations of <main>, and headlessui portals this panel out of it:
               `data-animate` would stay hidden forever here, so the same keyframes are applied directly.
               No leave animation needed on the items: they go out with the panel. -->
          <div class="mt-6 flow-root">
            <div class="-my-6 divide-y divide-gray-100">
              <div class="space-y-2 py-6">
                <button-nav-mobile
                  v-for="(item, index) in navHeaderItems"
                  :key="item.name"
                  :label="item.name"
                  :link="item.href"
                  :style="{ animationDelay: `${getStaggerDelay(index)}ms` }"
                  class="animate-fade-up motion-reduce:animate-none"
                  @click="emit('close', false)"
                />
              </div>

              <div class="py-6 space-y-3">
                <button-primary
                  link="/demo"
                  label="Demander une démo"
                  size="lg"
                  :style="{ animationDelay: `${getStaggerDelay(navHeaderItems.length)}ms` }"
                  class="w-full animate-fade-up motion-reduce:animate-none"
                  @click="emit('close', false)"
                />

                <button-nav-mobile
                  label="Se connecter"
                  :link="appUrl"
                  target="_blank"
                  :style="{ animationDelay: `${getStaggerDelay(navHeaderItems.length + 1)}ms` }"
                  class="text-center animate-fade-up motion-reduce:animate-none"
                  @click="emit('close', false)"
                />
              </div>
            </div>
          </div>
        </DialogPanel>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel, TransitionRoot, TransitionChild } from '@headlessui/vue'

import type { NavMobileProps, NavMobileEmits } from 'types/navigation'

const { opened: isMobileMenuOpened } = defineProps<NavMobileProps>()
const emit = defineEmits<NavMobileEmits>()

const config = useRuntimeConfig()
const env = config.public
const appUrl = env.APP_URL
</script>
